export default {
  getCardTransactions: state => state.cardTransactions,
  getCardTransactionsPage: state => state.cardPage
}
